"use client";

import {
  CardTransformed,
  CardsContainer,
  ContainerScroll,
  ReviewStars,
} from "../Testimonials/Ui/animated-cards-stack";
import "../Testimonials/Testimonials.css";

const TESTIMONIALS = [
  {
    id: "1",
    name: "Cata India",
    profession: "Web Designer",
    rating: 4.5,
    description:"Their digital marketing strategies and creative graphics have greatly improved our online presence. The team is responsive, timely, and understands our business goals well. Campaigns are well-executed with fresh, eye-catching designs. Highly recommended for impactful marketing and quality design work.",
    avatarUrl: "https://images.unsplash.com/photo-1580489944761-15a19d654956",
  },
  {
    id: "2",
    name: "Vinoth Govind",
    profession: "Frontend Developer",
    rating: 5,
    description:
      "Great team. They have been help us with the design of bags, menu, branding. Extraordinary support from Benny makes our brand stand out.",
    avatarUrl: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
  },
  {
    id: "3",
    name: "L Lingeshwar",
    profession: "Frontend Developer",
    rating: 5,
    description:
      "I have been working with ascent brandworks for a while now and u can say they are highly experienced from their presentation to their delivery ... Highly recommend for all ur marketing needs",
    avatarUrl: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
  },
  {
    id: "4",
    name: "Justine Leewen ",
    profession: "Frontend Developer",
    rating: 5,
    description:
      "One of the best places for all design and printing needs. The team goes the extra mile to deliver designs that perfectly match our ideas, even complex concepts. They listen carefully and bring ideas to life exactly as imagined. Special thanks to Benny for being prompt, dedicated, and ensuring on-time delivery. Best wishes to Ascent Brandworks. God bless!",
    avatarUrl: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
  },
  {
    id: "5",
    name: "Sundarapandian",
    profession: "Frontend Developer",
    rating: 5,
    description:
    "One of the best professionals in the industry. The team understands client requirements well and delivers with perfection. I’ve been associated with them for many years and highly recommend Ascent for corporate branding. Special appreciation to CEO Mr. Benny for his dedication and customer-focused approach. Wishing the Ascent team continued success.",
       avatarUrl: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
  },
];

export default function Testimonials() {
  return (
    <section className=" px-8 py-12" style={{backgroundColor:"#0D1F46"}}>
      <h2 className="text-center text-4xl font-semibold mt-3 mb-2 text-white">
       Testimonials
      </h2><br/>
     
      <ContainerScroll className="container  h-[150vh] sm:h-[300vh]  mt-5">
        <div
          className="sticky top-0 h-svh py-12"
          style={{ paddingTop: "10px" }}
        >
          <div style={{ marginTop: "80px" }}>
            {/* 
             <ContainerScroll
        className="
          relative
          mt-5
          h-[100vh] sm:h-[300vh]
          overflow-x-hidden
        "
      > */}
            <CardsContainer
              className="mx-auto   w-[65vw] sm:w-[350px]
              h-[270px] sm:h-[450px] mt-5 Cards "
            >
              {TESTIMONIALS.map((item, index) => (
                <CardTransformed
                  key={item.id}
                  arrayLength={TESTIMONIALS.length}
                  index={index + 1}
                >
                  <ReviewStars rating={item.rating} className="text-yellow-500 scale-90 sm:scale-100" />

                  <p className="text-center text-xs sm:text-sm">{item.description}</p>

                  <div className="flex items-center gap-4">
                 {/*  <Avatar className="h-8 w-8 sm:h-10 sm:w-10">
                      <AvatarImage src={item.avatarUrl} />
                      <AvatarFallback>{item.name[0]}</AvatarFallback>
                    </Avatar> */}

                    <div>
                      <p className="font-semibold text-sm sm:text-base">{item.name}</p>
                     {/*  <p className="text-[11px] sm:text-sm text-muted-foreground">
                        {item.profession}
                      </p> */}
                    </div>
                  </div>
                </CardTransformed>
              ))}
            </CardsContainer>
          </div>
        </div>
      </ContainerScroll>
    </section>
  );
}
